import { render, staticRenderFns } from "./NewClaimModal.vue?vue&type=template&id=7cce76b2&scoped=true&"
import script from "./NewClaimModal.vue?vue&type=script&lang=js&"
export * from "./NewClaimModal.vue?vue&type=script&lang=js&"
import style0 from "./NewClaimModal.vue?vue&type=style&index=0&id=7cce76b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cce76b2",
  null
  
)

export default component.exports